import React, { useEffect, useState, useRef, useContext } from 'react';
import { StateContext } from "./stateContext";
import TextDescription from './TextDescription';

function AudioTrack(props) {


    const { loadSubtitle, removeSubtitle } = useContext(StateContext)

    const audio = useRef(null);
    const [ direction, setDirection ] = useState(null);
    const [ playState, setPlayState ] = useState("stopped")
    const [ subObj, setsubObj ] = useState({ id: props.id, text: props.description, playState: "stopped" });

    const {fader, down, mediaRef} = props

    //START AUDIO AND SHOW SUBTITLE, AND UPDATE PLAYSTATE

    // MAKE A VOLUME CLIPPER IN BACKEND!!

    useEffect(() => {
        if (audio && direction === down) {
            audio.current.volume = Math.abs(fader) <= 1 ? Math.abs(fader) : 1;
            if (Math.abs(fader) > 0.035) {
                audio.current.play();
            }
            if (Math.abs(fader) === 0 && !audio.current.paused || Math.abs(fader) <= 0.035) {
                audio.current.pause()
            }
        }
        if (audio && direction !== down) {
            audio.current.pause()
        }
    }, [ fader, direction ]);

    useEffect(() => {
        mediaRef(audio.current)
    }, []);

    //UPDATE SUBTITLES TO REFLECT PLAYSTATE
    useEffect(() => {
        if (subObj && playState === "playing") {
            setsubObj({ ...subObj, playState: playState })
            loadSubtitle(subObj)
        }
        if(subObj && playState === "stopped") {
            removeSubtitle(subObj.id)
            setsubObj({ ...subObj, playState: playState })
        }
    }, [ playState ]);

    useEffect(() => {
        setDirection(props.direction)
    }, [ props.direction ]);




    return (
        <React.Fragment>
            <div className="contentContainer">
                <audio
                    style={{ display: "none", position: "fixed" }}
                    loop
                    onPlaying={() => { setPlayState("playing") }}
                    onPause={() => { setPlayState("stopped") }}
                    ref={audio}
                    controls src={`${process.env.REACT_APP_API_URL}${props.track}`}
                    type="audio/mpeg"
                >
                </audio>

            </div>
            {subObj && playState === "playing" ? 
            <TextDescription text={subObj.text} id={subObj.id} />
            : null
            }

        </React.Fragment>

    )
}

export default AudioTrack;